module.exports = __webpack_public_path__ + "static/media/vani-kola.df69eca6.jpeg";